import React from 'react'
import Image from '../../../images/buyerpolicies/Payment.png'

const Payment = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Payment</h2>
            <p>These are some of the most used payment methods that we accept:</p>
            <ul>
                <li>•	Cash On Delivery</li>
                <li>•	Online Payment</li>
            </ul>
            <p>When we receive your order, we do conduct a regular check for authorization and if you prefer to pay by cash, we will call you before the order has been dispatched.</p>
        </div>
      </div>
    </div>
  )
}

export default Payment
